import Button from "@material-ui/core/Button";
import { withSnackbar } from "notistack";
import React, { Component } from "react";
import { handleChangeEvent, handlePatch } from "../../../../utils/AxiosUtil";
import { toDateFormat, trimSpaces } from "../../../../utils/Util";
import * as enums from "../../../../utils/EnumMapping";
import ErrorAwareAmountField from "../../../common/inputfields/ErrorAwareAmountField";
import ErrorAwareDatePicker from "../../../common/inputfields/ErrorAwareDatePicker";
import ErrorAwareTextField from "../../../common/inputfields/ErrorAwareTextField";
import MyAutocomplete from "../../../common/inputfields/MyAutocomplete";
import PaymentMethodFormControl from "../../../common/inputfields/PaymentMethodFormControl";
import * as util from "./OutgoingBillUtil";

class ModifyOutgoing extends Component {
  componentDidMount() {
    console.log(this.props);
  }

  fields = util.fields;
  state = {
    selectedPaymentMethod: enums.getObjectByValue(
      enums.outPaymentMethods,
      this.props.row.paymentMethod
    ),
    prevPaymentMethod: enums.getObjectByValue(
      enums.outPaymentMethods,
      this.props.row.paymentMethod
    ),
    selectedCustomer: {
      value: this.props.row.customerId,
      label: this.props.row.customerName,
    },
    prevCustomer: {
      value: this.props.row.customerId,
      label: this.props.row.customerName,
    },
    selectedProject: this.props.row.projectId && {
      value: this.props.row.projectId,
      label: this.props.row.projectPublicId + "-" + this.props.row.location,
    },
    prevProject: {
      value: this.props.row.projectId,
      label: this.props.row.projectPublicId + "-" + this.props.row.location,
    },
    selectedCurrency: enums.currencies[0],

    billDate: new Date(this.props.row.billDate),
    fulfillmentDate: new Date(this.props.row.fulfillmentDate),
    paymentDeadline: new Date(this.props.row.paymentDeadline),

    vat: this.props.row.vat,
    amount: this.props.row.amount,

    publicId: this.props.row.publicId,
    billNumber: this.props.row.billNumber,
    comment: this.props.row.comment,

    customerRelatedDropDown: false,
    errors: new Map(),
  };

  handleSubmit = async (event) => {
    event.persist();
    event.preventDefault();

    const path = "/api/outgoingbill";
    const requestObject = {
      privateId: this.props.row.privateId,
      paymentMethod: this.state.selectedPaymentMethod.value,
      customerId: this.state.selectedCustomer.value,
      projectId: this.state.selectedProject.value,
      currency: this.state.selectedCurrency.value,

      billDate: toDateFormat(this.state.billDate),
      fulfillmentDate: toDateFormat(this.state.fulfillmentDate),
      paymentDeadline: toDateFormat(this.state.paymentDeadline),

      vat: trimSpaces(this.state.vat),
      amount: trimSpaces(this.state.amount),

      publicId: this.state.publicId,
      comment: this.state.comment,
    };
    handlePatch(path, requestObject, this);
  };

  render() {
    return (
      <form onSubmit={this.handleSubmit}>
        <div className="flex-form">
          <div className="input-group">
            <MyAutocomplete
              value={this.state.selectedCustomer}
              prevValue={this.state.prevCustomer}
              getOptions={util.promiseCustomerOptions}
              onChange={(e, v) => util.handleCustomerSelected(e, v, this)}
              label={"Megnevezés"}
              createLabel={"Új vevő"}
            />
          </div>
          <div className="input-group">
            <MyAutocomplete
              value={this.state.selectedProject}
              getOptions={() =>
                util.promiseProjectOptions(this.state.selectedCustomer)
              }
              onChange={(e, v) => util.handleProjectSelected(e, v, this)}
              disabled={this.state.customerRelatedDropDown}
              label={"Projekt"}
              createLabel={"Új projekt"}
              validate={(p) => util.isValidNewWork(p)}
              formatHint={"Munkaszám-Helyszín"}
              customFilter={(options, params) =>
                util.filterForProject(options, params)
              }
            />
          </div>
          <div className="input-group">
            <PaymentMethodFormControl
              options={enums.outPaymentMethods}
              value={this.state.selectedPaymentMethod}
              prevValue={enums.getObjectByValue(
                enums.outPaymentMethods,
                this.props.row.paymentMethod
              )}
              onChange={(e) => handleChangeEvent(e, this)}
            />
          </div>
          <div className="input-group">
            <ErrorAwareTextField
              required
              name="publicId"
              id="bill-number"
              label="Számlaszám"
              errors={this.state.errors}
              value={this.state.publicId}
              prevValue={this.props.row.publicId}
              onChange={(e) => handleChangeEvent(e, this)}
            />
          </div>
          <div className="input-group">
            <ErrorAwareDatePicker
              required
              id="bill-date"
              name="billDate"
              label="Számla kelte"
              errors={this.state.errors}
              value={this.state.billDate}
              prevValue={this.props.row.billDate}
              onChange={(value) => util.handleBillDateChange(value, this)}
            />
          </div>
          <div className="input-group">
            <ErrorAwareDatePicker
              required
              id="fullfillment-date"
              name="fullFillmentDate"
              label="Teljesítés kelte"
              errors={this.state.errors}
              value={this.state.fulfillmentDate}
              prevValue={this.props.row.fulfillmentDate}
              onChange={(value) =>
                util.handleFulfillmentDateChange(value, this)
              }
            />
          </div>
          <div className="input-group">
            <ErrorAwareDatePicker
              required
              id="payment-deadline-date"
              name="paymentDeadline"
              label="Fizetési határidő"
              errors={this.state.errors}
              value={this.state.paymentDeadline}
              prevValue={this.props.row.paymentDeadline}
              onChange={(value) =>
                util.handlePaymentDeadlineChange(value, this)
              }
            />
          </div>
          <div className="input-group">
            <ErrorAwareAmountField
              required
              id="amount"
              name="amount"
              label="Bruttó összeg"
              value={this.state.amount}
              prevValue={this.props.row.amount}
              errors={this.state.errors}
              onChange={(e) => handleChangeEvent(e, this)}
            />
          </div>
          <div className="input-group">
            <ErrorAwareAmountField
              required
              name="vat"
              label="Áfa összege"
              value={this.state.vat}
              prevValue={this.props.row.vat}
              errors={this.state.errors}
              onChange={(e) => handleChangeEvent(e, this)}
            />
          </div>
          <div className="input-group">
            <ErrorAwareTextField
              name="comment"
              id="comment"
              label="Megjegyzés"
              errors={this.state.errors}
              value={this.state.comment}
              prevValue={this.props.row.comment}
              onChange={(e) => handleChangeEvent(e, this)}
            />
          </div>
          {/*<div className='input-group'>
                            <FormControl variant="outlined" fullWidth>
                                <InputLabel id="currency-label">Pénznem</InputLabel>
                                <Select
                                    labelId="currency-label"
                                    id="currency"
                                    value={this.state.selectedCurrency}
                                    onChange={(event) => this.setState({ selectedCurrency: event.target.value })}
                                    label="Pénznem"
                                    disabled={true}>
                                    {enums.currencies.map((value, index) =>
                                        <MenuItem key={index} value={value}>{value.label}</MenuItem>
                                    )}
                                </Select>
                            </FormControl>
                                    </div>*/}
        </div>
        <div className="form-actions">
          <Button
            className="btn-submit"
            variant="contained"
            color="primary"
            type="submit"
          >
            {this.props.row.state === "RECEIVED" ? "Befogad" : "Módosít"}
          </Button>
        </div>
      </form>
    );
  }
}

export default withSnackbar(ModifyOutgoing);
